import "./bootstrap"
import $ from "jquery"

$(() => {
  $(".is-full-height").css({
    minHeight: $(window).height() - ($(".nav").outerHeight() + $(".main-footer").outerHeight() + 70),
  })

  $("#register-btn").click(() => {
    $("#register-form").show()
    $("#login-form").hide()

    $('#register-form input[name="name"]').focus()
  })

  $("#login-btn").click(() => {
    $("#register-form").hide()
    $("#login-form").show()

    $('#login-form input[name="password"]').focus()
  })
})
